import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { ShieldCheck, Download, Mail } from "lucide-react";

export default function ElginCertificateActions({ request, osNumber }) {
  const [busy, setBusy] = useState(false);
  const [mailing, setMailing] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(`/requests/${request.id}/elgin-certificate/pdf`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `Certificado-Garantia-Elgin-${osNumber}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Falha ao gerar o certificado.");
    } finally {
      setBusy(false);
    }
  };

  const email = async () => {
    setMailing(true);
    try {
      const { data } = await api.post(`/requests/${request.id}/elgin-certificate/email`);
      toast.success(`Certificado enviado para ${data.email}`);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Falha ao enviar o e-mail.");
    } finally {
      setMailing(false);
    }
  };

  return (
    <div className="rounded-lg border border-blue-200 bg-blue-50/60 p-3 space-y-2" data-testid="elgin-certificate-section">
      <Label className="text-sm flex items-center gap-1.5 text-[#0a2a6c]"><ShieldCheck className="h-4 w-4" /> Certificado de Garantia — Instalação Elgin</Label>
      <p className="text-xs text-slate-600">3 anos no conjunto e 10 anos no compressor, com data da instalação e da 1ª preventiva (+12 meses).</p>
      <div className="grid grid-cols-2 gap-2">
        <Button variant="outline" className="gap-1.5 border-[#1e7be0] text-[#0a2a6c] hover:bg-blue-100"
          onClick={download} disabled={busy} data-testid="elgin-cert-pdf-button">
          <Download className="h-4 w-4" /> {busy ? "Gerando..." : "Baixar certificado"}
        </Button>
        <Button variant="outline" className="gap-1.5 border-[#1e7be0] text-[#0a2a6c] hover:bg-blue-100"
          onClick={email} disabled={mailing} data-testid="elgin-cert-email-button">
          <Mail className="h-4 w-4" /> {mailing ? "Enviando..." : "Enviar por e-mail"}
        </Button>
      </div>
    </div>
  );
}
